module.exports = __webpack_public_path__ + "img/west-v.b2b347bd.jpg";